'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/AlertSuccess.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertSuccess = function AlertSuccess(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    {
      className: 'alert alert-success cp-alert-success', role: 'alert',
      'aria-live': 'polite', 'aria-atomic': 'true' },
    _react2.default.createElement(_baseIcons.CheckmarkCircle, null),
    children
  );
};

AlertSuccess.propTypes = {
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
};

exports.default = AlertSuccess;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/alerts/lib/components/success/components/AlertSuccess.component.js
// module id = 363
// module chunks = 0 1 4